module.exports = __webpack_public_path__ + "static/img/背景2.d9bc994.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/背景2.jpg
// module id = waDK
// module chunks = 1